import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PenLine, Loader2, Upload } from "lucide-react";
import { Switch } from "../ui/switch";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { api, fileUrl } from "../../lib/api";

const Pick = ({ label, id, onChange, testid }) => {
  const [busy, setBusy] = useState(false);
  const up = async (f) => {
    if (!f) return; setBusy(true);
    try { const r = await api.uploadFile(f); onChange(r.attachment_id); } catch { toast.error("تعذّر رفع الملف"); } finally { setBusy(false); }
  };
  return (
    <label className="flex cursor-pointer flex-col items-center gap-1 rounded-xl border border-dashed border-slate-300 p-2 text-xs text-slate-600 hover:border-indigo-400" data-testid={testid}>
      {id ? <img src={fileUrl(id)} alt={label} className="h-14 object-contain" /> : busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Upload className="h-5 w-5" />}
      {label}
      <input type="file" accept="image/*" className="hidden" onChange={(e) => { up(e.target.files?.[0]); e.target.value = ""; }} />
    </label>
  );
};

export const SigningPermCard = ({ uid }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.signingUsers().then((r) => { const u = (r.items || []).find((x) => x.user_id === uid || x.email === uid) || {}; setF({ can_sign: !!u.can_sign, signature_id: u.signature_id || "", stamp_id: u.stamp_id || "", sign_title: u.sign_title || "" }); }).catch(() => {});
  }, [uid]);
  if (!f) return null;
  const save = async () => {
    setBusy(true);
    try { await api.setSigning(uid, f); toast.success("تم حفظ صلاحية التوقيع والختم"); } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 space-y-2 rounded-2xl border border-indigo-200 bg-indigo-50/40 p-3" data-testid="signing-perm-card">
      <label className="flex items-center justify-between gap-2 text-sm font-bold text-indigo-900">
        <span className="flex items-center gap-1.5"><PenLine className="h-4 w-4" /> صلاحية التوقيع والختم</span>
        <Switch checked={f.can_sign} onCheckedChange={(v) => setF({ ...f, can_sign: v })} data-testid="signing-switch" />
      </label>
      <p className="text-[11px] text-slate-600">بعد تفعيلها لأي مستخدم، السندات والأوراق ما يظهر فيها إلا توقيع وختم أصحاب هذي الصلاحية، مع اسم المسؤول.</p>
      {f.can_sign && <>
        <Input value={f.sign_title} onChange={(e) => setF({ ...f, sign_title: e.target.value })} placeholder="المسمى تحت التوقيع (مثلاً مدير الموارد البشرية)" data-testid="signing-title" />
        <div className="grid grid-cols-2 gap-2">
          <Pick label="التوقيع" id={f.signature_id} onChange={(v) => setF({ ...f, signature_id: v })} testid="signing-signature" />
          <Pick label="الختم" id={f.stamp_id} onChange={(v) => setF({ ...f, stamp_id: v })} testid="signing-stamp" />
        </div>
      </>}
      <Button size="sm" onClick={save} disabled={busy || (f.can_sign && !f.signature_id)} data-testid="signing-save">حفظ التوقيع</Button>
    </div>
  );
};
